// AddressManagementScreen.tsx
import { MdLocationOff } from "react-icons/md";
import { useTheme } from "../../common/hooks/useTheme";
import { useSelector } from "react-redux";
import { selectIsOnline } from "../../store/slices/networkSlice";
import { MobileHeader } from "../../common/components/mobileHeader/MobileHeader";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import Button from "../../common/components/button/Button";
import AddressForm from "../../common/components/addressForm/AddressForm";
import { EmptyState } from "../../common/components/emptyState/EmptyState";
import styles from "./AddressManagementScreen.module.scss";
import { useAddressManagementScreen } from "./useAddressManagementScreen";
import AddressCard from "./addressCard/AddressCard";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";

export default function AddressManagementScreen() {
  const { theme } = useTheme();
  const {
    addresses,
    getList,
    adding,
    closeForm,
    startAdding,
    setDefaultAddress,
    deleteAddress,
  } = useAddressManagementScreen();
  const isOnline = useSelector(selectIsOnline);

  const showEmptyPlaceholder = addresses.length === 0 && !adding;

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta />

      <div className={styles.mobileOnly}>
        <MobileHeader
          title="Мои адреса"
          subtitle="Управляйте адресами доставки"
        />
      </div>

      <div className={styles.desktopOnly}>
        <ProductHeader
          title="Мои адреса"
          isFavorite={false}
          showFavorite={false}
          textColor={theme.text}
          borderColor={theme.border}
        />
      </div>

      <div className={styles.content}>
        {!adding && (
          <div className={styles.addButtonContainer}>
            <Button
              title={
                isOnline
                  ? "Добавить адрес"
                  : "Для управления адресами подключите интернет"
              }
              onClick={startAdding}
              variant="primary"
              icon={<MdLocationOff size={20} />}
              disabled={!isOnline}
              fullWidth
            />
          </div>
        )}

        {adding && (
          <div className={styles.formContainer}>
            <AddressForm getList={getList} onClose={closeForm} />
          </div>
        )}

        {showEmptyPlaceholder ? (
          <EmptyState
            icon={MdLocationOff}
            title="Нет сохраненных адресов"
            description="Добавьте адрес доставки, чтобы быстрее оформлять заказы"
          />
        ) : (
          addresses.length > 0 && (
            <div className={styles.addressesList}>
              {addresses.map((address) => (
                <AddressCard
                  key={address.id}
                  address={address}
                  setDefaultAddress={setDefaultAddress}
                  deleteAddress={deleteAddress}
                />
              ))}
            </div>
          )
        )}
      </div>
    </div>
  );
}
